// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"tabs_shadow__2JE6c","tabs":"tabs_tabs__2qggN","button":"tabs_button__3dssq","active":"tabs_active__5ij-t"};